import React from "react";
import ReceiptMaker from "../Dashboard/ReceiptMaker";

const ReceiptIcon = () => (
  <svg className="w-5 h-5 text-primary-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

const PlannerReceiptMaker = ({ selectedAppointment, isPinB }) => {
  // Pre-fill values if launching ReceiptMaker for a specific appointment
  const values = selectedAppointment
    ? {
        patient: {
          name: selectedAppointment.patientName || "",
          phoneNumber: selectedAppointment.patientPhone || "",
          age: selectedAppointment.patientAge || "",
          PID: selectedAppointment.PID || "",
          gender: selectedAppointment.patientGender || "Male",
          city: selectedAppointment.patientCity || "",
          pincode: selectedAppointment.patientPincode || "",
        },
      }
    : null;

  return (
    <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-4 md:p-6 space-y-4">
      <div className="pb-3 border-b border-gray-100">
        <h2 className="text-xl font-black text-gray-900 flex items-center gap-2">
          <ReceiptIcon />
          <span>Consultation Receipt Maker</span>
        </h2>
        <p className="text-xs text-gray-500 mt-0.5">
          Generate GST-compliant consultation receipts, tag fees, send receipts via WhatsApp, or view receipt history.
        </p>
      </div>

      <ReceiptMaker
        values={values}
        setFieldValue={() => {}}
        is_pin_b={isPinB}
        rcptServicesAccess={true}
        rcptListAccess={true}
        defaultExpanded={true}
        hideCollapse={true}
      />
    </div>
  );
};

export default PlannerReceiptMaker;
